import { MbcAssessmentNames, MbcScoreLabels, MbcLabel } from 'types/Visit/MeasurementBasedCare'

export const getMbcLabel = (title: MbcAssessmentNames, score: number) => {
  const MbcLabel: MbcLabel = { name: '', color: '' }

  const makeLabel = (label: MbcScoreLabels, color: string) => {
    MbcLabel.name = label
    MbcLabel.color = color
  }

  switch (title) {
    case MbcAssessmentNames.GAD_7: {
      if (score >= 0 && score < 5) makeLabel(MbcScoreLabels.SUBCLINICAL, 'bg-[#999999]')
      if (score > 4 && score < 10) makeLabel(MbcScoreLabels.MILD, 'bg-[#7496B2]')
      if (score > 9 && score < 15) makeLabel(MbcScoreLabels.MODERATE, 'bg-[#2FAFCC]')
      if (score > 14 && score < 22) makeLabel(MbcScoreLabels.SEVERE, 'bg-[#F16030]')
      if (score < 0 || score > 21) makeLabel(MbcScoreLabels.INVALID_SCORE, 'bg-fuchsia-800')
      break
    }

    case MbcAssessmentNames.PHQ_9: {
      if (score >= 0 && score < 5) makeLabel(MbcScoreLabels.SUBCLINICAL, 'bg-[#999999]')
      if (score > 4 && score < 10) makeLabel(MbcScoreLabels.MILD, 'bg-[#7496B2]')
      if (score > 9 && score < 15) makeLabel(MbcScoreLabels.MODERATE, 'bg-[#2FAFCC]')
      if (score > 14 && score < 20) makeLabel(MbcScoreLabels.MODERATELY_SEVERE, 'bg-[#E5998A]')
      if (score > 19 && score < 28) makeLabel(MbcScoreLabels.SEVERE, 'bg-[#F16030]')
      if (score < 0 || score > 27) makeLabel(MbcScoreLabels.INVALID_SCORE, 'bg-fuchsia-800')
      break
    }
  }

  return MbcLabel
}
